<navaar-header [color]="'transparent'" [z-index]="2">
  <div slot=custom-icon>
    <div class="wrapper-activity-icon" [class.custom-disabled]="inProcessToAddWishlist">
      <ng-container *ngIf="purchase?.pdpActionButtonState?.showCartOption">
       <img *ngIf="isLogin ? (purchase && loadComplete) : true" (click)="showDownloadPopup()"
          src="assets/icon-new/cart-icon.svg">
      </ng-container>
      <img *ngIf="!hasInWishlist" (click)="toggleWishlist(true)" src="assets/icon-new/bookmark.svg">
      <img *ngIf="hasInWishlist" (click)="toggleWishlist(false)" src="assets/icon-new/bookmark-full.svg">
      <img *ngIf="parametersService.clientId !== clientTypeEnum.iGap" (click)="share()" src="assets/icon-new/share.svg">
    </div>
  </div>
</navaar-header>
<ng-container *ngIf="loadComplete">
  <div *ngIf="dataBook" id="blured-cover"
    [ngStyle]="{backgroundImage: setBackground(image)}"></div>
  <div *ngIf="dataBook">
    <div class="container-pdp">
      <div id="container-cover">
        <div class="wrapper-cover">
          <img [lazySrc]="image" class="wrapper-img-slider" src="assets/img/placeholder.png" lazySrcVisible="visible"
            loading="lazy">
        </div>
      </div>
    </div>
    <div #containerScroll class="container-scroll-div">
      <div class="wrapper-scroll-div">
        <ng-container [ngSwitch]="dataBook.contentType">
          <ng-template [ngSwitchCase]="productType.AudioBook">
            <div class="container-title">
              <div class="wrapper-title">
                <p *ngIf="dataBook['authors'][0]">
                  <span>نویسنده:</span>
                  <b [innerText]="dataBook['authors'][0].firstName + ' ' + dataBook['authors'][0].lastName"></b>
                </p>
                <h2 [style.paddingTop.px]="0" [innerText]="dataBook.title"></h2>
              </div>
              <ng-container *ngTemplateOutlet="show_rate;context:{$implicit: rate}"></ng-container>
              <div class="wrapper-title">
                <p *ngIf="dataBook['narrators'][0]">
                  <span>گوینده:</span>
                  <b [innerText]="dataBook['narrators'][0].firstName + ' ' + dataBook['narrators'][0].lastName"></b>
                </p>
              </div>
            </div>
          </ng-template>
          <ng-template [ngSwitchCase]="productType.Podcast">
            <ng-container *ngTemplateOutlet="followerTemplate"></ng-container>
            <div class="container-title">
              <div class="wrapper-title">
                <h2 style="padding-top: 30px" [innerText]="dataBook.title"></h2>
              </div>
              <ng-container *ngTemplateOutlet="show_rate;context:{$implicit: rate}"></ng-container>
              <ng-container *ngTemplateOutlet="factors;"></ng-container>
            </div>
          </ng-template>
          <ng-template [ngSwitchCase]="productType.AudioSeries">
            <div class="container-title">
              <div class="wrapper-title">
                <p *ngIf="dataBook['authors'][0]">
                  <span>نویسنده:</span>
                  <b [innerText]="dataBook['authors'][0].firstName + ' ' + dataBook['authors'][0].lastName"></b>
                </p>
                <h2 style="padding-top: 0" [innerText]="dataBook.title"></h2>
              </div>
              <ng-container *ngTemplateOutlet="show_rate;context:{$implicit: rate}"></ng-container>
              <ng-container *ngTemplateOutlet="factors;"></ng-container>
            </div>
          </ng-template>
          <ng-template [ngSwitchCase]="productType.Capsule">
            <div class="container-title">
              <div class="wrapper-title">
                <p *ngIf="dataBook['authors'][0]">
                  <span>نویسنده:</span>
                  <b [innerText]="dataBook['authors'][0].firstName + ' ' + dataBook['authors'][0].lastName"></b>
                </p>
                <h2 style="padding-top: 0" [innerText]="dataBook.title"></h2>
              </div>
              <ng-container *ngTemplateOutlet="show_rate;context:{$implicit: rate}"></ng-container>
              <div *ngIf="dataBook.narrators.length > 0" class="wrapper-title">
                <p>
                  <span>گوینده:</span>
                  <b [innerText]="dataBook.narrators[0].firstName + ' ' + dataBook.narrators[0].lastName"></b>
                </p>
              </div>
            </div>
          </ng-template>
        </ng-container>
        <navaar-pdp-button (open-dialog-download)="showDownloadPopup()" (open-dialog-market)="openMarketsDialog($event)" [dataBook]="dataBook" (show-download-dialog)="showDownloadPopup()" [isLogin]="isLogin"
          [purchase]="purchase"></navaar-pdp-button>

        <div id="section-description">
          <h2>توضیحات</h2>
          <p class="wrapper-description" [textContent]="dataBook.abstract">
          </p>
          <span class="more-text-style" (click)="showDescription()">
            ادامه مطلب...
          </span>
        </div>
        <ng-container
          *ngIf="(dataBook.contentType == productType.Podcast) ||  (dataBook.contentType == productType.AudioSeries) ">
          <div class="hr-style"></div>
          <div class="list-episods" [routerLink]="['/clp','listItem', infoEpisod.genreId]"
            [queryParams]="{title: infoEpisod.title,contentType: productType[dataBook.contentType]}">
            <div>
              <img src="assets/icon-new/list.svg">
              <p>اپیزودهای دیگر</p>
            </div>
            <div>
              <p [textContent]="infoEpisod.count"></p>
              <navaar-chevron-icon></navaar-chevron-icon>
            </div>
          </div>
          <div class="hr-style"></div>
        </ng-container>
        <div class="container-badge">
          <ng-container *ngFor="let item of dataBook.genres">
            <span [routerLink]="['/clp',item.identifier]" [queryParams]="{ title: item.name }"
              [textContent]="item.name"></span>
          </ng-container>
        </div>
        <ng-template [ngIf]="ratoToComment > 0" [ngIfElse]="noComment">
          <div *ngIf="rate" class="container-rate has-comment">
            <ng-template [ngIf]="isLogin" [ngIfElse]="comment_no_login">
              <p>امتیاز و نظر شما به این اثر</p>
            </ng-template>
            <ng-template #comment_no_login>
              <p>برای ثبت امتیاز و نظر لطفا وارد شوید</p>
            </ng-template>
            <div class="container-star-rate">
              <navaar-star-icon (rate)="showPopupRateToComment($event)" [rate-item]="ratoToComment | number"
                [style]="{'stroke-width': '2px', 'stroke': '#818181', 'width':'26px', 'height': '25px', 'margin':' 0 7px'}">
              </navaar-star-icon>
            </div>
          </div>
        </ng-template>
        <div class="container-show-comment" *ngIf="comment.length > 0">
          <div class="wrapper-show-comment">
            <span>
              دیدگاه
              <b>({{totalCountComment | number}})</b>
            </span>
            <div class="wrapper-btn-show-comment">
              <navaar-button (onClick)="goToComment()" [type-button]="'button'" [class-name]="'style-btn-all-yellow'"
                [color-name]="'no-color'">
                <span>همه دیدگاه‌ها</span>
                <navaar-chevron-icon color="#ffb500"></navaar-chevron-icon>
              </navaar-button>
            </div>
          </div>
          <ng-template ngFor [ngForOf]="comment" let-item>
            <navaar-comment-template [comment]="item"></navaar-comment-template>
          </ng-template>
        </div>
      </div>
      <div class="container-sliders">
        <ng-template [ngIf]="recomendation.length > 0" [ngIfElse]="sameAudiobook" list>
          <ng-template [ngIf]="dataBook && dataBook.identifier">
            <ng-container *ngFor="let item of recomendation">
              <navaar-carousel *ngIf="item.items && item.items.length > 0" [show-rate]="true"
                [style-show-all]="'yellow'" [items]="item" [title]="item.title" [typeOfCarousel]="carouselType.Simple_H"
                [identifier]="dataBook.identifier" [type-url]="item.listApi">
              </navaar-carousel>
            </ng-container>
          </ng-template>
        </ng-template>
        <ng-template #sameAudiobook>
          <navaar-carousel *ngIf="recommendData?.items && recommendData.items.length > 0" [show-rate]="true"
            [style-show-all]="'yellow'" [items]="recommendData" [title]="'عناوین مشابه'"
            [typeOfCarousel]="carouselType.Simple_H" [identifier]="dataBook.identifier" [type-url]="'recommend'">
          </navaar-carousel>
        </ng-template>
        <br>
        <!-- *ngIf="dataBook.contentType != productType.Podcast || dataBook.contentType != productType.Series" -->
        <navaar-agents-slider *ngIf="false" [title]="getTitleAgetsList(dataBook.contentType)" [items]="artistList">
        </navaar-agents-slider>
      </div>
    </div>
  </div>
  <navaar-container-scroll [isPlayAnimation]="true" [title]="dataBook.title" [showHeader]="true" (close)="closeDescPopup($event)"
    [show]="isShowDescription" *ngIf="dataBook">
    <navaar-tabs-scroll-spy (clicked-tab)="onClickedTab($event)">
      <navaar-tab-scroll-spy [title]="'توضیحات'" [en-title]="'desc'" [attr.id]="'description-audiobook'"
        [id]="'description-audiobook'">
        <p id="description-audiobook-style" [textContent]="dataBook.abstract"></p>
      </navaar-tab-scroll-spy>
      <navaar-tab-scroll-spy [title]="'مشخصات'" [en-title]="'specs'" [attr.id]="'specification-audiobook'"
        [id]="'specification-audiobook'">
        <div class="tab-table">
          <div class="tab-table-cell" *ngIf="dataBook.authors">
            <span>نویسنده</span>
            <span [textContent]="dataBook.authors | objectToString : 'firstName' : 'lastName'"></span>
          </div>
          <div class="tab-table-cell" *ngIf="dataBook.translators.length > 0">
            <span>مترجم</span>
            <span [textContent]="dataBook.translators | objectToString : 'firstName' : 'lastName'"></span>
          </div>
          <div class="tab-table-cell" *ngIf="dataBook.narrators.length > 0">
            <span>گوینده</span>
            <span [textContent]="dataBook.narrators | objectToString : 'firstName' : 'lastName'"></span>
          </div>
          <div class="tab-table-cell" *ngFor="let attr of dataBook.attributes; last as isLast">
            <span [textContent]="attr.attributeKey"></span>
            <span [textContent]="attr.attributeValue"></span>
          </div>
          <div class="tab-table-cell" *ngIf="dataBook.duration">
            <span>مدت</span>
            <span [textContent]="dataBook.duration | persianTime"></span>
          </div>
          <div class="tab-table-cell" *ngIf="dataBook.size">
            <span>حجم دانلود</span>
            <span>
              <b>{{dataBook.size}}</b>
              مگابایت
            </span>
          </div>
          <div class="tab-table-cell" *ngIf="dataBook.numOfChapters">
            <span>تعداد فصل</span>
            <span>{{dataBook.numOfChapters}}</span>
          </div>
          <div class="tab-table-cell" *ngIf="dataBook.genres">
            <span>دسته</span>
            <span [textContent]="dataBook.genres | objectToString : 'name'"></span>
          </div>
          <div class="tab-table-cell" *ngIf="dataBook.printPublisher">
            <span>ناشر</span>
            <span [textContent]="dataBook.printPublisher.name"></span>
          </div>
          <div class="tab-table-cell" *ngIf="dataBook.audioPublisher">
            <span>ناشر صوتی</span>
            <span [textContent]="dataBook.audioPublisher.name"></span>
          </div>
          <div class="tab-table-cell" *ngIf="dataBook.publicationDate">
            <span>سال انتشار نسخه چاپی</span>
            <span [textContent]="dataBook.publicationDate | getYearsOfDate"></span>
          </div>
          <div class="tab-table-cell" *ngIf="dataBook.audioPublicationDate">
            <span>سال انتشار نسخه صوتی</span>
            <span [textContent]="dataBook.audioPublicationDate | getYearsOfDate"></span>
          </div>
          <div class="tab-table-cell" *ngIf="dataBook.languages">
            <span>زبان</span>
            <span [textContent]="dataBook.languages | objectToString : 'name'"></span>
          </div>
          <div class="tab-table-cell" *ngIf="dataBook.isbn">
            <span>شابک</span>
            <span>
              &lrm;
              <b [textContent]="dataBook.isbn"></b>
            </span>
          </div>
        </div>
      </navaar-tab-scroll-spy>
    </navaar-tabs-scroll-spy>
  </navaar-container-scroll>
</ng-container>
<ng-template #noComment>
  <div *ngIf="isLogin ? rate : true" class="container-rate no-comment" id="container-no-comment">
    <ng-template [ngIf]="isLogin" [ngIfElse]="comment_no_login">
      <p>
        نظرتان در مورد این اثر را با دیگران به اشتراک بگذارید
      </p>
    </ng-template>
    <ng-template #comment_no_login>
      <p>برای ثبت امتیاز و نظر لطفا وارد شوید</p>
    </ng-template>
    <span (click)="showPopupRateToComment({id: '', index: ratoToComment})">
      ثبت نظر
      <navaar-chevron-icon [color]="'#307fff'"></navaar-chevron-icon>
    </span>
    <div class="container-star-rate">
      <navaar-star-icon (rate)="showPopupRateToComment($event)" [rate-item]="ratoToComment | number"
        [style]="{'stroke-width': '2px', 'width':'26px', 'height': '25px', 'margin':' 0 7px'}"></navaar-star-icon>
    </div>
  </div>
</ng-template>
<navaar-dialog-download-pdp [(showPopupDownload)]="showPopupDownload" [isLogin]="isLogin" [purchase]="purchase"
  [dataBook]="dataBook" [product]="product" (openMarketDialog)="openMarketsDialog($event)" (refreshStatePurchase)="refreshStatePurchase()"></navaar-dialog-download-pdp>
<ng-container #containerMarkets></ng-container>
<navaar-send-rate-and-comment *ngIf="isLogin ?  (dataBook && rate) : (dataBook && true)"
  [audiobook-id]="dataBook.audioBookId" [show]="isShowRate" [(rate)]="ratoToComment" [title]="dataBook.title"
  [main-rate]="isLogin ? rate.userRate : 0" (onSubmit)="onSubmitPopupRateToComment($event)">
</navaar-send-rate-and-comment>
<ng-template #factors>
  <div class="wrapper-title">
    <p>
      <span>عوامل:</span>
      <ng-template ngFor [ngForOf]="artistList.slice(0,2)" let-item let-isLast="last">
        <b [textContent]="item.name"></b>
        <span *ngIf="!isLast">-</span>
        <!-- *ngIf="isLast && artistList.length > 2" -->
        <b *ngIf="false" class="rounded-border">
          سایر
        </b>
      </ng-template>
    </p>
  </div>
</ng-template>
<ng-template #show_rate let-rate>
  <div *ngIf="rate" class="wrapper-rating">
    <navaar-star-icon (rate)="rateToItem($event)" [rate-item]="rate.average | number"
      [style]="{'width': '11px', 'height': '11px'}"></navaar-star-icon>
    <b [textContent]="rate.average | number:'1.0-1'"></b>
    <span class="rate-style">({{this.rate.count | number}}&nbsp;رای)</span>
    <span class="duration" [textContent]="dataBook.duration"></span>
  </div>
</ng-template>
<ng-template #followerTemplate></ng-template>
<!-- containet plcaeholder -->
<div class="container" *ngIf="!loadComplete">
  <div class="container-cover">
    <img src="assets/icon-new/empty-book.svg">
  </div>
  <div class="container-circles">
    <div></div>
    <div></div>
    <div></div>
  </div>
  <div class="scrollbar container-scroll-div">
    <div class="wrapper-scroll-bar">
      <div class="first-line">
        <div>
          <div class="animated-background"></div>
        </div>
      </div>
      <div class="second-line">
        <div>
          <div class="animated-background"></div>
        </div>
        <div>
          <div class="animated-background"></div>
        </div>
      </div>
      <div class="thirth-line">
        <div>
          <div class="animated-background"></div>
        </div>
      </div>
      <div class="container-button-play">
        <button>
        </button>
      </div>
    </div>
  </div>
</div>
<!-- carosell placeholder -->
<ng-template #carosellPlaceHolder>
  <div class="container-placeHolder-slider">
    <div class="container-title-placeHolder-slider">
      <p></p>
    </div>
    <div class="container-main-placeHolder-slider">
      <div class="wrapper-container">
        <div class="items" *ngFor="let i of [1,2,3,4,5]">
          <div class="container-img">
            <navaar-image-icon></navaar-image-icon>
          </div>
          <div class="container-desc">
            <p></p>
            <p></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
